import React from 'react'
 
const BbelowFooter = () => {
    return (
        <div data-aos="fade-up" className="p-4 lg:px-16  mx-auto">
            {/* <div className="bg-white p-6 rounded-lg shadow-md border border-black"> */}
            <div className="text-xl text-center font-bold bg-white p-6 rounded-lg  mb-4 shadow-md border border-black">
                Pricing Plan: <span className="font-normal text-black">Absolutely free – Our gift to help you evaluate and enhance your Executive Presence.</span>
            </div>
            <div data-aos="fade-up" className="mt-4 p-6 bg-blue-600 text-white text-center rounded-lg">
                <p className="text-lg">Make an appointment with Coach Kshitij to explore one-on-one Executive Coaching</p>
                <a  rel="noreferrer" href="https://calendly.com/epcoachkshitij/" target='_blank' className="mt-4 inline-block bg-white text-blue-600 font-bold py-2 px-4 rounded-lg shadow-md hover:bg-gray-100 transition duration-300">
                    MAKE APPOINTMENT
                </a>
            </div>
            {/* </div> */}
        </div>
    )
}

export default BbelowFooter